import {
  GET_PROJECT_BILLING_RATE_TEMPLATES,
  CREATE_PROJECT_BILLING_RATE_TEMPLATE,
  DELETE_PROJECT_BILLING_RATE_TEMPLATE,
  UPDATE_PROJECT_BILLING_RATE_TEMPLATE,
  GET_PROJECT_BILLING_RATES,
  CREATE_PROJECT_BILLING_RATES,
  DELETE_PROJECT_BILLING_RATE,
  UPDATE_PROJECT_BILLING_RATE,
} from '../../state/actionTypes';

import { getIdMap } from '../../helpers/helpers';
import { removeFromObject, updateObject } from '../../helpers/stateHelpers';

const initialState = {
  templates: {},
  projectRates: {},
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_PROJECT_BILLING_RATE_TEMPLATES: {
      const {
        payload: {
          templates = [],
        } = {},
      } = action;
      return {
        ...state,
        templates: getIdMap(templates),
      };
    }
		case GET_PROJECT_BILLING_RATES: {
      const {
        payload: {
					projectId,
          projectRates = [],
        } = {},
      } = action;
      return {
        ...state,
        projectRates: {
					...state.projectRates,
					[projectId]: getIdMap(projectRates),
				}
      };
    }
    case CREATE_PROJECT_BILLING_RATE_TEMPLATE: {
      const {
        payload: {
          template = {},
        } = {},
      } = action;
      const newTemplates = { ...state.templates };
      newTemplates[template.id] = template;
      return {
        ...state,
        templates: newTemplates,
      };
    }
    case CREATE_PROJECT_BILLING_RATES: {
      const {
        payload: {
          projectId,
          projectRates = [],
        } = {},
      } = action;
      const oldProjectRates = state.projectRates[projectId];
      return {
        ...state,
        projectRates: {
          ...state.projectRates,
          [projectId]: {
            ...oldProjectRates,
            ...getIdMap(projectRates),
          },
        },
      };
    }
    case DELETE_PROJECT_BILLING_RATE_TEMPLATE: {
      const {
        payload: {
          id,
        } = {},
      } = action;
      return {
        ...state,
        templates: removeFromObject({ oldObject: state.templates, id }),
      };
    }
		case DELETE_PROJECT_BILLING_RATE: {
      const {
        payload: {
          projectId,
          id,
        } = {},
      } = action;
			const oldProjectRates = state.projectRates[projectId];
      return {
        ...state,
        projectRates: {
					...state.projectRates,
					[projectId]: removeFromObject({ oldObject: oldProjectRates, id }),
				}
      };
    }
    case UPDATE_PROJECT_BILLING_RATE_TEMPLATE: {
      const {
        payload: {
          id,
          data = {},
        } = {},
      } = action;
      return {
        ...state,
        templates: updateObject({ oldObject: state.templates, id, newData: data }),
      };
    }
    case UPDATE_PROJECT_BILLING_RATE: {
      const {
        payload: {
          projectId,
          id,
          data = {},
        } = {},
      } = action;
			const oldProjectRates = state.projectRates[projectId];
      return {
        ...state,
        projectRates: {
					...state.projectRates,
					[projectId]: updateObject({ oldObject: oldProjectRates, id, newData: data }),
				}
      };
    }
    default:
      return state;
  }
}